/* assets/custom-analytics-scroll.js
 * GA4 scroll-depth milestones (25 / 50 / 75 / 90%), each fired once per pageview.
 * Distinct from GA4 Enhanced Measurement's single 90% `scroll` event.
 * Spec: docs/plans/analytics-click-tracking.md
 * Depends on global.js (window.throttle), loaded before this.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var MARKS = [25, 50, 75, 90];
  var fired = {};

  function depthPercent() {
    var doc = document.documentElement;
    var body = document.body || {};
    var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
    var docHeight = Math.max(doc.scrollHeight || 0, body.scrollHeight || 0);
    var scrollable = docHeight - window.innerHeight;
    if (scrollable <= 0) return 100; // short page: count as fully seen
    return Math.min(100, Math.round((scrollTop / scrollable) * 100));
  }

  function check() {
    var p = depthPercent();
    for (var i = 0; i < MARKS.length; i++) {
      var m = MARKS[i];
      if (p >= m && !fired[m]) {
        fired[m] = true;
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'scroll_depth', { percent: m });
        }
        window.dataLayer.push({ event: 'scroll_depth', percent: m });
      }
    }
  }

  var handler = typeof window.throttle === 'function' ? window.throttle(check, 250) : check;
  window.addEventListener('scroll', handler, { passive: true });

  if (document.readyState !== 'loading') check();
  else document.addEventListener('DOMContentLoaded', check);
})();
